import React from "react";
import {
  Box,
  Container,
  SimpleGrid,
  Heading,
  Text,
  Image,
  VStack,
  Badge,
} from "@chakra-ui/react";
import { motion } from "framer-motion";
import { Link as RouterLink } from "react-router-dom";
import { categories } from "../data/categories";

const MotionBox = motion(Box);

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1,
    },
  },
};

const itemVariants = {
  hidden: { y: 20, opacity: 0 },
  visible: {
    y: 0,
    opacity: 1,
    transition: {
      duration: 0.5,
    },
  },
};

const Categories: React.FC = () => {
  return (
    <Box py={8}>
      <Container maxW="1400px">
        <VStack spacing={8} align="stretch">
          <Heading 
            textAlign="center" 
            size="2xl"
            color="green.600"
            fontWeight="bold"
            letterSpacing="tight"
          >
            Shop by Category
          </Heading>
          <Text textAlign="center" fontSize="lg" color="gray.600">
            Discover our wide range of premium cosmetics and beauty products
          </Text>
          <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={8}>
            {categories.map((category) => (
              <MotionBox
                key={category.id}
                variants={itemVariants}
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
                as={RouterLink}
                to={`/category/${category.id}`}
                cursor="pointer"
                _hover={{ textDecoration: "none" }}
              >
                <Box
                  borderWidth="1px"
                  borderRadius="lg"
                  overflow="hidden"
                  bg="white"
                  shadow="md"
                  transition="all 0.3s"
                  _hover={{
                    shadow: "lg",
                    transform: "translateY(-4px)",
                  }}
                >
                  <Image
                    src={category.image}
                    alt={category.name}
                    height="200px"
                    width="100%"
                    objectFit="cover"
                  />
                  <VStack p={4} align="start" spacing={2}>
                    <Heading size="md">{category.name}</Heading>
                    <Text color="gray.600" noOfLines={2}>
                      {category.description}
                    </Text>
                    <Badge colorScheme="green">
                      {category.productCount} Products
                    </Badge>
                  </VStack>
                </Box>
              </MotionBox>
            ))}
          </SimpleGrid>
        </VStack>
      </Container>
    </Box>
  );
};

export default Categories;
